<template>
  <div v-if="pageLoading"><LoadingAnimation /></div>
  <div v-else class="ctpx-common-thread ctpx-common-thread--archive">
    <div class="header-bg">
      <div class="container-fluid">
        <div class="row d-flex justify-content-center">
          <div class="col">
            <label>Common Thread</label>
            <h1 class="display-1">More Stories & Films</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="msearch d-block d-md-none">
      <div class="container-fluid">
        <div class="row">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Search Common Thread"
              aria-label="Search Common Thread"
              aria-describedby="basic-addon2"
              v-model="searchQuery"
            />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xml:space="preserve"
                  baseProfile="tiny"
                  class="icon icon-search"
                  viewBox="0 0 200 200"
                >
                  <path
                    fill-rule="evenodd"
                    d="m168.76 158.74-32.09-32.1a60.21 60.21 0 1 0-10.02 10.02l32.1 32.09a7.08 7.08 0 1 0 10.01-10.01zm-46.49-37.15-.36.32c-.11.11-.22.23-.32.36a46.04 46.04 0 1 1 .68-.68z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="search d-none d-md-block">
      <div class="container-fluid">
        <div class="row">
          <div class="col d-none d-md-block">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Search Common Thread Stories and Films"
                aria-label="Search Common Thread Stories and Films"
                aria-describedby="basic-addon2"
                v-model="searchQuery"
              />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xml:space="preserve"
                    baseProfile="tiny"
                    class="icon icon-search"
                    viewBox="0 0 200 200"
                  >
                    <path
                      fill-rule="evenodd"
                      d="m168.76 158.74-32.09-32.1a60.21 60.21 0 1 0-10.02 10.02l32.1 32.09a7.08 7.08 0 1 0 10.01-10.01zm-46.49-37.15-.36.32c-.11.11-.22.23-.32.36a46.04 46.04 0 1 1 .68-.68z"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <!--.col-7-->
        </div>
        <!--.row-->
      </div>
      <!--.container-fluid-->
    </div>
    <div v-if="storiesLoading"><LoadingAnimation /></div>
    <div v-else class="container-fluid">
      <div class="row">
        <div class="sort">
          <div class="sort-dropdown" v-bind:class="{ 'sort-open': isSortOpen }">
            <a
              class="sort-button"
              role="button"
              id="dropdownSort"
              v-on:click="isSortOpen = !isSortOpen"
            >
              Sort By</a
            >
            <div class="sort-drop filters">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Films & Reels"
                  name="sortby"
                  v-model="filters.videos"
                />
                <label class="form-check-label" for="Films & Reels">
                  Films & Reels
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="People"
                  name="sortby"
                  v-model="filters.people"
                />
                <label class="form-check-label" for="People"> People </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Planet"
                  name="sortby"
                  v-model="filters.planet"
                />
                <label class="form-check-label" for="Planet"> Planet </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="Gear"
                  name="sortby"
                  v-model="filters.gear"
                />
                <label class="form-check-label" for="Gear"> Gear </label>
              </div>
              <hr />
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Newest First"
                  name="sortby"
                  v-model="sortSelected"
                />
                <label class="form-check-label" for="Newest First">
                  Newest First
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Oldest First"
                  name="sortby"
                  v-model="sortSelected"
                />
                <label class="form-check-label" for="Oldest First">
                  Oldest First
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="A to Z"
                  name="sortby"
                  v-model="sortSelected"
                />
                <label class="form-check-label" for="A to Z"> A to Z </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Z to A"
                  name="sortby"
                  v-model="sortSelected"
                />
                <label class="form-check-label" for="Z to A"> Z to A </label>
              </div>
            </div>
            <!-- .sort-drop -->
          </div>
        </div>
      </div>
      <!-- sort -->
      <div class="row">
        <div v-if="!stories.length" class="col text-center">
          <h1>No stories found</h1>
          <p>
            Please try removing some filters <br />or refresh the page and try
            again.
          </p>
        </div>
      </div>
      <div class="row stories-grid ctpx-short-sec">
        <template v-for="story in displayedStories.slice(0, 9)">
          <storyCard :storyDetails="story.attributes" :storyId="story.id" />
        </template>
        <template v-if="showMoreStories">
          <template
            v-for="story in displayedStories.slice(9, displayedStories.length)"
          >
            <storyCard :storyDetails="story.attributes" :storyId="story.id" />
          </template>
        </template>
      </div>
      <!-- load more after first 9 stories-->
      <div v-if="stories.length > 9 && !showMoreStories" class="row">
        <div class="col d-flex justify-content-center">
          <button @click="showMoreStories = true" class="btn btn-default mb-4">
            Load More Stories
          </button>
        </div>
      </div>
      <!-- load more after fist 24 stories -->
      <div
        v-if="
          showMoreStories &&
          !showAllStories &&
          storiesMetaData.pagination.total > 24
        "
        class="row"
      >
        <div class="col d-flex justify-content-center">
          <button @click="getMoreStories()" class="btn btn-default mb-4">
            Load More Stories
          </button>
        </div>
      </div>
      <!-- load and display next page of stories -->
      <div
        v-if="
          showAllStories &&
          storiesMetaData.pagination.page !=
            storiesMetaData.pagination.pageCount &&
          storiesMetaData.pagination.total >= stories.length &&
          displayedStories.length < stories.length &&
          stories.length > 0
        "
        class="row"
      >
        <div class="col d-flex justify-content-center">
          <button @click="getMoreStories()" class="btn btn-default mb-4">
            Load More Stories
          </button>
        </div>
      </div>
    </div>
    <!--.container-fluid-->
    <!-- spotify playlist -->
    <spotify
      v-if="spotifyPlacement === SpotifyPlacement.allPages"
      :spotifyTitle="spotifyTitle"
      :playlistLink="spotifyLink"
      :bgImg="spotifyImg"
      :description="spotifyDesc"
    />
  </div>
  <!-- .ctpx-common-thread -->
</template>

<script src="./ctrl-common-thread-archive.js"></script>
